import React from "react";
// import {
//   home,
//   bnb,
//   background,
//   icon1,
//   icon2,
//   icon3,
//   rocket,
//   footer,
// } from "../images/images";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Grid, Hidden, Typography, Box, Container } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@chakra-ui/react";
import JoinSale from "./join-sale/JoinSale";
// import Loading from "../loading";
const useStyles = makeStyles((theme) => ({
  titleHeading: {
    background:
      "linear-gradient(   0deg,   rgba(225, 172, 84, 1) 0%,   rgba(253, 239, 175, 1) 25%,   rgba(219, 159, 66, 1) 50%,   rgba(253, 239, 175, 1) 75%,   rgba(225, 172, 84, 1) 100% )",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  styledBg: {
    background:
      "linear-gradient(   0deg,   rgba(225, 172, 84, 1) 0%,   rgba(253, 239, 175, 1) 25%,   rgba(219, 159, 66, 1) 50%,   rgba(253, 239, 175, 1) 75%,   rgba(225, 172, 84, 1) 100% )",
  },
}));
export default function MainPage() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    userWalletAddress,
    stakeContract = "",
    hodlTokenContract = "",
    web3,
    referesh,
  } = useSelector((state) => state.UserReducer);
  const [loading, setloading] = React.useState(false);
  const { spacing } = useTheme();

  return (
    <>
      <Box className={classes.homeContainer}>
        <Container maxWidth="lg">
          <Typography component="div" align="center">
            <Box
              component="h3"
              color="secondary.main"
              fontSize={spacing(5)}
              pt={spacing(1)}
              my={0}
              style={{ textTransform: "uppercase" }}
            >
              Cardence is the solitary genuinely decentralized launchpad
              administration on Binance Smart Chain
            </Box>

            <Box
              component="p"
              my={0}
              fontSize={spacing(2.8)}
              color="secondary.main"
            >
              Most launchpads require the designer group to be talked with, pay
              huge charges, and are casted a ballot upon to utilize their
              administration. Not any longer, anybody can list their tokens on
              Cardence. Cardence will even help you in advertising for nothing.
              We have faith in local area driven crypto that is really
              decentralized. We have lower expenses than contenders and help you
              en route
            </Box>
            <Box
              display="flex"
              justifyContent="center"
              className={classes.styledButton}
              flexWrap="wrap"
              my={spacing(1)}
            >
              <Link to="/create-sale">
                <Button
                  bg="#00B7C5"
                  color="white"
                  width={[
                    "100%", // 992px upwards
                  ]}
                >
                  Create Presale
                </Button>
              </Link>
            </Box>
          </Typography>
          <JoinSale />
        </Container>
      </Box>
    </>
  );
}
